enum GRIEVANCE_ACTION_TYPES {
  GET_GRIEVANCE_LIST = 'GET_GRIEVANCE_LIST',
  GET_GRIEVANCE_LIST_SUCCESS = 'GET_GRIEVANCE_LIST_SUCCESS',
  SET_IS_SHOW_REPLY = 'SET_IS_SHOW_REPLY',
  SET_IS_SHOW_CHAT_THREAD = 'SET_IS_SHOW_CHAT_THREAD',
  SAVE_GRIEVANCE_RESPONSE = 'SAVE_GRIEVANCE_RESPONSE',
  FETCH_DETAILED_GRIEVANCE = 'FETCH_DETAILED_GRIEVANCE',
  FETCH_CLAIM_LIST = 'FETCH_CLAIM_LIST',
  SUBMIT_GRIEVANCE_REPLY = 'SUBMIT_GRIEVANCE_REPLY',
  SEARCH_CLAIM_LIST = 'SEARCH_CLAIM_LIST',
  SET_PAGE_INDEX_LIST = 'SET_PAGE_INDEX_LIST',
  SET_SELECTED_CLAIMS = 'SET_SELECTED_CLAIMS',
  RAISE_NEW_GRIEVANCE = 'RAISE_NEW_GRIEVANCE',
  RESET_GRIEVANCE = 'RESET_GRIEVANCE',
  CLOSE_TICKET = 'CLOSE_TICKET',
  RAISE_OR_UPDATE_GRIEVANCE = 'RAISE_OR_UPDATE_GRIEVANCE',
  FETCH_GRIEVANCE_LIST = 'FETCH_GRIEVANCE_LIST',
  REPLY_GRIEVANCE = 'REPLY_GRIEVANCE',
}

export default GRIEVANCE_ACTION_TYPES;
